// import axios from 'axios'
let title = ''
// axios({
//   url: '/jy-mobile-vod-he-ui/config.json',
//   method: 'get'
// }).then(res => {
//   title = res.data['APPLICATION_TITLE']
// })// 修改项目title

export default function getPageTitle (pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
